import React, { useEffect } from "react";
import DashboardInsight from "./partials/DashboardInsight";
import InvoiceGraph from "./partials/InvoiceGraph";
import RecentInvoice from "./partials/RecentInvoice";
import DashboardInvoiceChart from "./partials/DashboardInvoiceChart";
import { useSelector, useDispatch } from "react-redux";
import { getInvoiceAnalytics } from "../../redux/reducers/invoiceSlice";

export default function Dashboard() {
  const user = useSelector((state) => state.auth.userDetail);
  const activeBusinessId = useSelector((state) => state.business.activeBusinessId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (activeBusinessId) {
      dispatch(getInvoiceAnalytics({ businessId: activeBusinessId }));
    }
  }, [dispatch, activeBusinessId]);


  return (
    <div className="container-fluid px-4">

      {/* Greeting */}
      <div className="py-4">
        <h5 className="fw-bold text-dark mb-0">
          Hello, {user?.fullName || "Back"}! 👋
        </h5>
        <p className="text-muted small mb-0">
          Here's what's happening with your business today.
        </p>
      </div>

      {/* Stats row */}
      <DashboardInsight />

      {/* Chart + Recent invoices */}
      <div className="row g-4">
        <div className="col-lg-4">
          <DashboardInvoiceChart />
        </div>
        <div className="col-lg-8">
          <RecentInvoice />
        </div>
      </div>

    </div>
  );
}
